module.exports = __webpack_public_path__ + "img/cba-inversiones-turismo.23c1761b.png";